exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Communication-module__container___j-44E{display:grid;grid-template-columns:auto;height:-moz-fit-content;height:fit-content;gap:1rem;padding:0 1.5rem 1.5rem}@media screen and (min-width:768px){.Communication-module__container___j-44E{height:auto;grid-template-columns:275px auto}}", ""]);

// exports
exports.locals = {
	"container": "Communication-module__container___j-44E"
};